

import MonitorApi from './src/Monitor'



let apis = {
   MonitorApi
};

export default apis;
